import { LAST_UPDATED_ON } from 'modules/intelligentInsights/constants';
import { FC } from 'react';
import styled from 'styled-components';
import { Skeleton } from 'ui/skeleton';
import { caption, colors } from 'ui/theme';

export const IndexContainerRefreshText = styled.p`
  ${caption};
  color: ${colors.textSecondary};
`;

export type LastUpdatedDateProps = {
  isLoading: boolean;
  lastUpdatedText: string;
};
export const LastUpdatedDate: FC<LastUpdatedDateProps> = ({ isLoading, lastUpdatedText }) => {
  return isLoading ? (
    <Skeleton width={156} height={16} />
  ) : (
    <IndexContainerRefreshText>
      {LAST_UPDATED_ON} {lastUpdatedText}
    </IndexContainerRefreshText>
  );
};
